export default "__VITE_ASSET__DZ2u9Aov__"